import React from 'react';
import { DomainsPermissions } from '@wix/domains-serverless-interface';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
export const useDomainPermissions = () => {
    const accountState = DomainsApiClient.hooks.useDomainsAccount({});
    const userPermissions = React.useMemo(() => accountState.data && new Set(accountState.data?.domainPermissions), [accountState.data?.domainPermissions]);
    const canPurchaseDomain = () => userPermissions?.has(DomainsPermissions.AccountLevelPurchaseDomain) ||
        userPermissions?.has(DomainsPermissions.SiteLevelPurchaseDomain);
    const canManageDomains = () => userPermissions?.has(DomainsPermissions.AccountLevelManageDomains) ||
        userPermissions?.has(DomainsPermissions.SiteLevelManageDomains);
    const canManageDomainsAccountLevel = () => userPermissions?.has(DomainsPermissions.AccountLevelManageDomains);
    const isPermitted = (permission) => userPermissions?.has(permission);
    return {
        error: accountState.error,
        isLoading: accountState.isLoading,
        refetch: accountState.refetch,
        isPermitted,
        canPurchaseDomain,
        canManageDomains,
        canManageDomainsAccountLevel,
    };
};
export const useCheckDomainPermissions = ({ checkPermissions = ['purchase'], }) => {
    const { canPurchaseDomain, canManageDomains, canManageDomainsAccountLevel } = useDomainPermissions();
    const checks = {
        purchase: canPurchaseDomain(),
        connect: canManageDomains() || canManageDomainsAccountLevel(),
    };
    return {
        get all() {
            return checkPermissions?.every((perm) => checks[perm]);
        },
        get some() {
            return checkPermissions?.some((perm) => checks[perm]);
        },
    };
};
//# sourceMappingURL=useDomainPermissions.js.map